import { gql } from '@apollo/client/core';
import useQuery from '../hooks/useQuery';

export type TenantsResponse = {
  tenants: string[];
};

export const GET_ALL_TENANTS = gql`
  query tenants {
    tenants
  }
`;

export const useGetAllTenants = () => {
  const { data, isLoading, error } = useQuery<string[], TenantsResponse>({
    query: GET_ALL_TENANTS,
    responseField: 'tenants',
  });

  return {
    tenants: data || [],
    isLoading,
    error,
  };
};
